import { create_instance } from '../init';

class Creator {
    getCreator() {
        return create_instance.get('/creator').catch(function(error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                return false;
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
            } else {
                // Something happened in setting up the request that triggered an Error
            }
        });
    }
    putCreator(data) {
        return create_instance.put('/creator', data);
    }
    getSubscriptionPricing() {
        return create_instance.get('/creator/subscription/pricing');
    }
    purchaseSubscription(pricing) {
        return create_instance.post(
            `/creator/subscription/purchase/${pricing}`
        );
    }
}

export default new Creator();
